import FooterTalentCareer from './FooterTalentCareer.vue';

export default function install(Vue) {
  Vue.component(FooterTalentCareer.name, FooterTalentCareer)
}
